import React, { useEffect, useContext } from 'react';
import { Webservice } from '../services/Webservice';
import { StoreState, Store } from './Store';
import { useParams } from 'react-router-dom';
import { Header } from './Header';
import { RedocStandalone, OperationItem, SideMenu } from 'redoc';
import { OperationItem as LocalOperationItem } from '../redoc/src/components/ContentItems/ContentItems';
import { SideMenu as LocalSideMenu } from '../redoc/src/components/SideMenu';
import { ErrorResponse } from '../services/model';
import { ErrorElement } from './ErrorElement';
import { RedocOptions } from '../redoc/src/RedocOptions';

// Overwrites the render of the OperationItem with our own
OperationItem.prototype.render = LocalOperationItem.prototype.render;

// Overwrites the render of the SideMenu with our own
SideMenu.prototype.render = LocalSideMenu.prototype.render;

export const APIDoc: React.FC = () => {
    const { error, openApiSpec } = useContext(Store);
    const { identifier, apiVersion } = useParams();

    useEffect(() => {
        if (identifier !== undefined) {
            const version = apiVersion ? apiVersion : '';
            // TODO: For now, we handle the /documentation/{identifier} paths still
            // for which we default to the latest published API in the backend
            // to not break the existing links.
            // https://dev.azure.com/schwarzit/schwarzit.stackit-core-platform/_backlogs/backlog/Service-Infrastructure/Epics/?workitem=652107
            Webservice.getAPI(identifier, version)
                .then((openApiSpec) => {
                    StoreState.set({ openApiSpec: openApiSpec });
                })
                .catch((error: ErrorResponse) => {
                    StoreState.set({ error: error });
                });
        }
    }, [identifier, apiVersion]);

    if (error) {
        return <ErrorElement error={error} />;
    }

    return (
        <div>
            <Header logoHref="/apis" />
            <RedocStandalone spec={openApiSpec} options={RedocOptions} />
        </div>
    );
};
